import JoinDiscordInfoCard from "@core-components/JoinDiscordInfoCard";
import SSBackgroundImage from "@core-components/backgroundImage/BackgroundImage";
import SSBgImageHeadline from "@core-components/backgroundImage/components/BgImageHeadline";
import Emoji from "@core-components/emoji/Emoji";
import SSHeadline from "@core-components/title/SSHeadline";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Container, Flex, SimpleGrid, Stack, Text } from "@mantine/core";
import LoLFAQ from "@modules/lol/faq/LoLFAQ";
import SEO from "@modules/seo/SEO";
import { Trans } from "react-i18next";
import HelpCenterInfoCards from "../components/HelpCenterInfoCards";

const FaqSupport = () => {
  const { t } = useAppTranslation("pages.support");

  return (
    <>
      <SEO description={t("seo.description")} title={t("seo.title")} />
      <Stack align="center" className="pb-10">
        <SSBackgroundImage>
          <SSBgImageHeadline
            props={{
              title: {
                order: 1,
              },
            }}
          >
            <SSWhiteText>{t("banner.title")}</SSWhiteText>
            &nbsp;
            <Emoji.Hand size={45} />
          </SSBgImageHeadline>
        </SSBackgroundImage>
        <SimpleGrid
          className="relative w-full pb-20"
          cols={{ base: 1, sm: 2 }}
          verticalSpacing={50}
        >
          <Flex className="w-full" justify="flex-end">
            <Stack align="left" className="lg:w-[550px]" justify="center">
              <SSHeadline
                props={{
                  stack: {
                    align: "left",
                  },
                  title: {
                    size: 35,
                  },
                }}
              >
                <SSLoLGradientText>{t("headline")}</SSLoLGradientText>
              </SSHeadline>
              <Text className="font-inter font-normal text-primary-white">
                <Trans i18nKey="pages.support.description">
                  Nous sommes là pour vous aider et répondre à toutes vos
                  questions.
                  <br />
                  <br />
                  Discutez avec notre équipe et obtenez des réponses rapides sur
                  les caractéristiques des produits, les prix et plus encore..
                  <br />
                  <br />
                  Nous sommes prêts à répondre à toutes vos questions dans les
                  plus brefs délais.
                </Trans>
              </Text>
            </Stack>
          </Flex>
          <Flex className="w-full" justify="center">
            <Container className="!w-[500px] p-0">
              <JoinDiscordInfoCard text={t("joinDiscord.text")} />
            </Container>
          </Flex>
        </SimpleGrid>

        <HelpCenterInfoCards />

        <LoLFAQ />
      </Stack>
    </>
  );
};

export default FaqSupport;
